module.exports = __webpack_public_path__ + "static/media/img107.0e215b12.png";